import * as React from 'react';

const SvgCurrencyInCircle = (props) => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z'
      fill='black'
      fillOpacity='0.87'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.8787 7H11.1213V8.10662C10.2015 8.24931 9.44087 8.63388 8.89811 9.26882C8.30094 9.96741 8 10.9311 8 12.1078V16H9.80929V12.1756C9.80929 11.3129 9.97642 10.7244 10.2527 10.3381C10.4595 10.049 10.7444 9.84947 11.1213 9.73706V14.8806H12.8787V9.73706C13.2556 9.84947 13.5405 10.049 13.7473 10.3381C14.0236 10.7244 14.1907 11.3129 14.1907 12.1756V16H16V12.1078C16 10.9311 15.6991 9.96741 15.1019 9.26882C14.5591 8.63388 13.7985 8.24931 12.8787 8.10662V7Z'
      fill='black'
      fillOpacity='0.87'
    />
  </svg>
);

export default SvgCurrencyInCircle;
